import { useInfiniteQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { axios, queryClient } from '@apps-common/lib'
import { IUnitScheduledQueueBasicModel } from '@apps-common/types/portal/unit-scheduled'

export const QUERY_KEY_MY_MONITORING_GET_UNIT_SCHEDULE_HISTORY_BY_SCHEDULE = (scheduledId?: number, take?: number) =>
  ['getMyMonitoringUnitScheduleHistoryBySchedule', scheduledId, take].filter(Boolean)

const getUnitScheduledHistoryByScheduled = async (
  scheduledId: number,
  skip: number,
  take: number
): Promise<IUnitScheduledQueueBasicModel[]> =>
  axios
    .get(`/my-monitoring/sites/GetScheduledHistoryBySchedule?scheduledId=${scheduledId}&skip=${skip}&take=${take}`)
    .then((res) => res.data?.data)

type Props = {
  scheduledId: number
  take: number
  enabled?: boolean
}

export const useMyMonitoringGetUnitScheduledHistoryByScheduled = ({ scheduledId, take, enabled }: Props) => {
  const { isLoading, isFetching, isRefetching, isError, data, refetch, fetchNextPage, hasNextPage } = useInfiniteQuery({
    queryKey: QUERY_KEY_MY_MONITORING_GET_UNIT_SCHEDULE_HISTORY_BY_SCHEDULE(scheduledId, take),
    initialPageParam: 0,
    enabled,
    queryFn: ({ pageParam = 0 }) => getUnitScheduledHistoryByScheduled(scheduledId, pageParam, take),
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage?.length < take) {
        return null
      }

      return allPages?.reduce((acc, curr) => acc + (curr?.length || 0), 0)
    }
  })

  useEffect(
    () => () => {
      queryClient.removeQueries({ queryKey: QUERY_KEY_MY_MONITORING_GET_UNIT_SCHEDULE_HISTORY_BY_SCHEDULE() })
    },
    []
  )

  return { isLoading, isFetching, isRefetching, isError, data, refetch, fetchNextPage, hasNextPage }
}
